import React from 'react';
import { Section, Heading } from '@carbon/react';
import { useTheme } from '../contexts/ThemeContext';
import PageContainer from '../components/PageContainer';
import ResidentsTable from '../components/ResidentsTable';

const Residents = () => {
  const { theme } = useTheme();
  const isDarkMode = theme === 'g100';

  return (
    <PageContainer>
      <Section style={{
        padding: 0,
        maxWidth: '100%',
        margin: 0,
        height: '100%'
      }}>
        {/* Header */}


        {/* Residents Table Component */}
        <div style={{
          padding: 0,
          height: '100%'
        }}>
          <ResidentsTable />
        </div>
      </Section>
    </PageContainer>
  );
};

export default Residents;
